import { render, staticRenderFns } from "./RptAllDevTraTot.vue?vue&type=template&id=63a6712f"
import script from "./RptAllDevTraTot.vue?vue&type=script&lang=js"
export * from "./RptAllDevTraTot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports